// import styles from './Inicio.module.css';
import imgHome from 'imagens/home-obs-drogas.png';
import Cards from 'components/Opcoes';
import Sobre from 'components/Sobre'
import Noticias from 'components/Noticias';
import SendIcon from '@mui/icons-material/ArrowForward';
import {Box, Button, Grid} from '@mui/material';
import { DeviceProvider, useDevice } from 'components/DeviceContext.js';
import MapaAssistencia from 'pages/Mapa/MapaAssistencia/'
import Cookies from 'components/Cookies'


const BrLg = () => <Box component="br" sx={{ display: { xs: 'none', lg: 'block' } }} />;
function Inicio() {
	const { isMobile, isLaptop, isDesktop } = useDevice();

	return (
		<DeviceProvider>
			<Grid container
				  sx={{
					  display: 'flex',
					  flexDirection: isMobile ? 'column' : 'row',
					  justifyContent: 'center',
					  alignItems: 'center',
					  flexWrap: { xs: 'wrap', lg: 'nowrap' },
					  margin: isMobile ? '1rem' : '0.6rem 0',
					  paddingLeft: isDesktop ? '2em' : '0',
					  paddingBottom: '3em',
					  userSelect: 'none',
					  WebkitUserSelect: 'none',
					  MozUserSelect: 'none',
				  }}
			>
				<Grid	item xs={11} sm={12}	md={12}	lg={5} xl={4}
					sx={{
						marginLeft: isMobile ? '0': isLaptop ? '0' : '8rem',
						justifyContent: isMobile ? 'center' : '',
						alignItems: isMobile ? 'center' : '',
						flexDirection: 'column',
						display: isMobile ? 'flex' : ''
					}}
				>
					<h1
						style={{
							fontSize: isMobile ? '1.8rem' : isLaptop ? '2.2rem' : '3.1rem',
							textAlign: isMobile ? 'center' : 'center',
							marginBottom: '1rem',
							color: 'var(--azul-escuro)',
							lineHeight: isMobile ? '1.15em' : '1.05em',
							fontWeight: '900',
							letterSpacing: isMobile ? '0.02em' : isLaptop ? '0.04em' : '0.1em',
							maxWidth: isDesktop ? 'none' : '980px',
							marginInline: 'auto'
						}}
					>
						Pesquisas e <BrLg/>
						estudos acerca <BrLg/>
						da temática <BrLg/>
						das drogas e <BrLg/>
						os municípios
					</h1>


					<h2
						style={{
							fontWeight: '400',
							fontSize: isMobile ? '1.25rem' : isLaptop ? '1.4rem' : '1.6rem',
							textAlign: isMobile ? 'center' : 'center',
							marginBottom: '1rem',
							letterSpacing: isMobile ? '0.01em' : '0.02em',
							lineHeight: 1.25,
							maxWidth: isDesktop ? 'none' : '820px',
							marginInline: 'auto'
						}}
					>
						Auxiliando os gestores municipais <BrLg/>
						com conteúdos e informações <BrLg/>
						de qualidade desde 2011
					</h2>

					{/* <Button
						variant="outlined"
						size={isMobile ? "small" : "large"}
						endIcon={<SendIcon />}
						sx={{
							width: isMobile ? 'auto' : '100%',
							maxWidth: '300px',
							marginTop: '1em',
							borderRadius: '1.2em',
							justifyContent: 'space-around',
							border: '2px solid var(--azul-escuro)',
							fontSize: isMobile ? '1em' : '1.4em'
						}}
					>
						Conheça mais
					</Button> */}
				</Grid>

				<Grid
					item
					xs={12}
					lg={6}
					xl={7}
					sx={{ display: { xs: "none", lg: "block" } }}
				>
					<Box
						component="img"
						src={imgHome}
						alt="Logo da CNM"
						sx={{
							width: "100%",
							height: "auto",
							py: { lg: 2 },
						}}
					/>
				</Grid>
			</Grid>

			<Grid sx={{ backgroundColor: '#F7F8FD', padding: '3em 1em' }}>
				<Cards />
			</Grid>

			<Grid>
				<MapaAssistencia />
			</Grid>

			<Grid sx={{ backgroundColor: 'var(--azul-escuro)', padding: '3em 1em', minHeight: isMobile ? '' : '50vh' }}>
				<Noticias />
			</Grid>

			<Grid>
				<Sobre />
			</Grid>

			<Cookies />
		</DeviceProvider>
	);
}

export default Inicio;
